import { SoftwareLicence, SoftwareLicenceSummary } from "./softwareLicence";

export enum SoftwareKeys {
  SOFTWARE_ID = "softwareId",
  NAME = "name",
  BUSINESS_DESCRIPTION = "businessDescription",
  URL = "url",
  SOFTWARE_LICENCES = "softwareLicences",
}

export interface Software {
  [SoftwareKeys.SOFTWARE_ID]: string;
  [SoftwareKeys.NAME]: string;
  [SoftwareKeys.BUSINESS_DESCRIPTION]: string;
  [SoftwareKeys.URL]: string;
  [SoftwareKeys.SOFTWARE_LICENCES]: SoftwareLicenceSummary[];
}
